<template>
  <settings-modal class="card-phone-number-edit-modal">
    <template slot="heading">Edit phone number</template>

    <v-text-field
      v-model="form.phoneNumber"
      class="t-phone-field"
      label="Phone number"
      :error-messages="getValidationErrorMessage('phoneNumber')"
    />

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-edit-card-phone"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || loading"
        @click="onSaveButtonClick"
      >save</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_CARD_UPDATE } from '@/events/cards'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import IssuingApi from '@/services/Api/IssuingApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'CardPhoneNumberEditModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        fieldErrorCustomMessages: {
          phoneNumber: {
            VALIDATION_ERROR_PATTERN: 'Invalid phone number format. Example: +371 2966191'
          }
        },
        form: { phoneNumber: null },
        requiredFields: ['phoneNumber'],
        cardPhoneNumberUpdateApiRequest: new ApiRequest(IssuingApi.updateCardPhoneNumber)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      cardId () {
        return this.modal.data.cardId
      },
      phoneNumber () {
        return this.modal.data.phoneNumber
      },
      loading () {
        return this.cardPhoneNumberUpdateApiRequest.loading
      },
      error () {
        return this.cardPhoneNumberUpdateApiRequest.error
      }
    },
    created () {
      this.form.phoneNumber = this.phoneNumber
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onSaveButtonClick () {
        this.cardPhoneNumberUpdateApiRequest
          .execute(this.cardId, this.form.phoneNumber)
          .then(this.cardPhoneNumberUpdateSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      cardPhoneNumberUpdateSuccessHandler () {
        this.$eventHub.$emit(EVENT_CARD_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Phone number has been successfully edited.' }
          })
        }, 100)
      }
    }
  }
</script>
